<template>
    <div class="wabident-color-picker">
        <compact-picker :value="value" @input="updateValue" :palette="palette">
        </compact-picker>
    </div>
</template>

<script>
export default {
    props: ['value'],
    data() {
        return {
            palette: [
                "#F06292",
                "#EDC0C1",
                "#BA68C8",
                "#9575CD",
                "#7986CB",
                "#4FC3F7",
                "#4DD0E1",
                "#4DB6AC",
                "#C1DBDF", 
                "#81C784",
                "#AED581",
                "#DCE775",
                "#FFF176",
                "#FFB74D",
                "#FF8A65",
                "#A1887F",
                "#ECE1CC",
                "#D5D2C9",
                "#D8B46C",
            ]
        }
    },
    methods: {
        updateValue(val) {
            console.log(val);
            this.$emit('input', val);
        }
    }

}
</script>

<style lang="scss"></style>